import { store } from '@/app/store'
import { adminApi } from '@/data/admin/api/admin_api'
import type { ChangeAdminPasswordPayload } from '@/domain/settings/entities/settings.entity'

export class SettingsRtkDatasource {
  async changePassword(payload: ChangeAdminPasswordPayload): Promise<void> {
    const result = await store.dispatch(
      adminApi.endpoints.changeAdminPassword.initiate({
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
      })
    )
    if (result.error) {
      throw result.error
    }
  }
}
